import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField'
import Div from '@jumbo/shared/Div'
import { Button } from '@mui/material'
import { Form, Formik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

const ArticleCategoryForm = ({
  category,
  onAddCategory,
  onEditCategory,
  onCancel
}) => {
  const { t } = useTranslation()
  const ArticleCategorySchema = Yup.object().shape({
    label: Yup.string().required(t('pages.articleCategories.labelRequired')),
    slug: Yup.string().required(t('pages.articleCategories.slugRequired'))
  })

  return (
    <Formik
      validateOnChange={true}
      initialValues={category || { label: '' }}
      validationSchema={ArticleCategorySchema}
      onSubmit={async data => {
        const handler = category ? onEditCategory : onAddCategory
        handler(data)
      }}
    >
      <Form style={{ textAlign: 'left' }} noValidate>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <JumboTextField
            fullWidth
            required
            name='label'
            label={t('pages.presentation.label')}
          />
        </Div>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <JumboTextField
            fullWidth
            required
            name='slug'
            label={t('pages.articleCategories.slug')}
          />
        </Div>
        <Div
          sx={{
            mt: 2,
            mb: 1,
            mx: 2,
            gap: '4px',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button size='normal' onClick={onCancel}>
            {t('buttons.cancel')}
          </Button>
          <Button type='submit' variant='contained' size='normal'>
            {t('buttons.ok')}
          </Button>
        </Div>
      </Form>
    </Formik>
  )
}

export default ArticleCategoryForm
